var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_1",
    fill: "#76CCCC",
    ry: 30,
    rx: 30,
    cy: 32,
    cx: 32
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#252730",
    d: "m41.70771,32.7395c0.3897,-0.4084 0.3897,-1.0706 0,-1.479l-6.353,-6.6551c-0.39,-0.4084 -1.0221,-0.4084 -1.4118,0c-0.3899,0.4084 -0.3899,1.0705 0,1.4789l5.6471,5.9157l-5.6471,5.9157c-0.3899,0.4084 -0.3899,1.0705 0,1.4789c0.3897,0.4084 1.0218,0.4084 1.4118,0l6.353,-6.6551zm-19.7077,-0.7395c0,0.5775 0.4682,1.0457 1.0458,1.0457l17.9559,0l0,-2.0915l-17.9559,0c-0.5776,0 -1.0458,0.4682 -1.0458,1.0458z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.de20a98389e00cb3c713c3d120b79ef4.svg";
export { ForwardRef as ReactComponent };